import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getCarbonOutput, getCarbonOutputTarget} from '../../../../../store/reducers/outputs/carbonOutput';

interface Props
{
    carbon_output: number;
    carbon_target: number;
}

import './CarbonMetreHint.scss';

class CarbonMetreHint extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        return <div styleName={'carbon-metre-hint'}>

            <div styleName={'hint'}>

                <p>82% - 87% off your power should be generated from low-carbon sources by 2032</p>

            </div>

        </div>
    }
}


const mapStateToProps = (state, props) =>
{
    return {
        carbon_output: getCarbonOutput(state),
        carbon_target: getCarbonOutputTarget(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(CarbonMetreHint);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/game-ui/carbon-metre/CarbonMetreHint.tsx